import React, { useEffect } from 'react';
import { ActivityIndicator, Modal, StyleSheet, View } from 'react-native';

import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';

import { ds } from '@/components/lib/design.system';

import { Screen } from '../../components/ScreenComponent';
import { useUserStore } from '../../hooks/use-user-store';

const styles = StyleSheet.create({
    spinner: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

export const LogoutScreen = () => {
    const navigation = useNavigation<NativeStackNavigationProp<{ Intro: undefined }>>();
    const actions = useUserStore(state => state.actions);
    const session = useUserStore(state => state.session);
    const loading = useUserStore(state => state.loading);

    useEffect(() => {
        actions.logout();
    }, [actions, session, navigation]);

    return (
        <Screen>
            <Modal visible={loading} animationType="fade" transparent style={styles.spinner}>
                <View style={styles.spinner}>
                    <ActivityIndicator color={ds.colorValue.icon.primary} size={'large'} />
                </View>
            </Modal>
        </Screen>
    );
};
